import React, { useEffect, useState, useContext } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Grid, TextField, ButtonGroup } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format, differenceInCalendarDays } from 'date-fns';
import { toast } from 'react-toastify';
import './button.css';
import { AuthContext } from "../../context/Auth/AuthContext";
import { useTheme } from '@material-ui/core';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: true,
            text: 'Respostas',
            position: 'left',
        },
        datalabels: {
            display: true,
            anchor: 'start',
            offset: -30,
            align: "start",
            color: "#fff",
            textStrokeColor: "#000",
            textStrokeWidth: 2,
            font: {
                size: 20,
                weight: "bold",
            },
            formatter: (value) => {
                return value > 0 ? value : '';
            },
        }
    },
};

export const ChartsMetaResponses = () => {
    const theme = useTheme();
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [responsesData, setResponsesData] = useState({ data: [], count: 0 });
    const [viewMode, setViewMode] = useState(null);
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    const isMultiDay = differenceInCalendarDays(finalDate, initialDate) >= 1;

    useEffect(() => {
        if (companyId) {
            handleGetResponsesData();
        }
    }, [companyId]);

    useEffect(() => {
        if (!isMultiDay) {
            setViewMode(null);
        }
    }, [isMultiDay]);

    const dataCharts = {
        labels: responsesData && responsesData?.data.length > 0 && responsesData?.data.map((item) => (item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data)),
        datasets: [
            {
                label: 'Respostas Campanha META',
                data: responsesData?.data.length > 0 && responsesData?.data.map((item) => {
                    return Number(item.total) || 0;
                }),
                backgroundColor: '#4CAF50',
            },
        ],
    };

    const handleGetResponsesData = async () => {
        try {
            let url = `/dashboard/campaign-meta-responses?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`;
            if (viewMode) {
                url += `&groupBy=${viewMode}`;
            }
            const { data } = await api.get(url);
            setResponsesData(data);
        } catch (error) {
            toast.error('Erro ao buscar respostas de campanhas META');
        }
    };

    const handleViewModeChange = (mode) => {
        setViewMode(mode);
    };

    useEffect(() => {
        if (companyId && isMultiDay && viewMode) {
            handleGetResponsesData();
        }
    }, [viewMode]);

    return (
        <>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                Respostas Campanha META ({responsesData?.count})
            </Typography>

            <Grid container spacing={2} alignItems="center">
                <Grid item>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={initialDate}
                            onChange={(newValue) => { setInitialDate(newValue) }}
                            label="Data Inicial"
                            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={finalDate}
                            onChange={(newValue) => { setFinalDate(newValue) }}
                            label="Data Final"
                            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item>
                    <Button style={{ backgroundColor: '#4CAF50', top: '10px' }} onClick={handleGetResponsesData} variant='contained'>Filtrar</Button>
                </Grid>
                {isMultiDay && (
                    <Grid item>
                        <ButtonGroup size="small" style={{ top: '5px' }}>
                            <Button
                                variant={(!viewMode || viewMode === 'day') ? 'contained' : 'outlined'}
                                style={(!viewMode || viewMode === 'day')
                                    ? { backgroundColor: '#4CAF50', color: '#fff' }
                                    : {}
                                }
                                onClick={() => handleViewModeChange('day')}
                            >
                                Por Dia
                            </Button>
                            <Button
                                variant={viewMode === 'hour' ? 'contained' : 'outlined'}
                                style={viewMode === 'hour'
                                    ? { backgroundColor: '#4CAF50', color: '#fff' }
                                    : {}
                                }
                                onClick={() => handleViewModeChange('hour')}
                            >
                                Por Hora
                            </Button>
                        </ButtonGroup>
                    </Grid>
                )}
            </Grid>
            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px' }} />
        </>
    );
};
